<app-step
  description="Opisz dodatkowe prace naprawcze"
  [nextEnabled]="nextEnabled()"
  nextLabel="ZAPISZ"
  (nextStepClicked)="zapiszKomentarz()"
  (previousStepClicked)="wroc()">

  <div class="o-flex o-flex--grids mt-5">
    <div class="o-flex__item u-flex-1/1@desktop u-flex-1/1@small align-self-stretch">
      <form [formGroup]="formularzUszkodzenia">
        <textarea rows="16" formControlName="komentarz" class="c-input"></textarea>
      </form>
    </div>
  </div>
</app-step>
